/**
 * Thin haptic feedback wrapper. Every native tap that would benefit from a
 * "physical" feel (Install eSIM, Buy, biometric unlock) calls one of these.
 * On the web build these are no-ops so browser users see zero change.
 */

import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';
import { isNative } from './platform';

export async function hapticLight() {
  if (!isNative()) return;
  try { await Haptics.impact({ style: ImpactStyle.Light }); } catch (_) {}
}

export async function hapticMedium() {
  if (!isNative()) return;
  try { await Haptics.impact({ style: ImpactStyle.Medium }); } catch (_) {}
}

export async function hapticSuccess() {
  if (!isNative()) return;
  try { await Haptics.notification({ type: NotificationType.Success }); } catch (_) {}
}

export async function hapticError() {
  if (!isNative()) return;
  try { await Haptics.notification({ type: NotificationType.Error }); } catch (_) {}
}
